// import React, { useState, useEffect } from "react";

// const GetData = () => {
//   const [residents, setResidents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // API base URL - change this to your actual backend URL
//   console.log("--------->>>>", residents);
//   const API_BASE_URL = "https://waapi.deetyasoft.com";

//   useEffect(() => {
//     fetchResidents();
//   }, []);

//   const fetchResidents = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/api/user/getAllResidents`);

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       setResidents(data);
//       setError(null);
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching residents:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Function to get image URL
//   const getImageUrl = (fileName) => {
//     if (!fileName) return null;
//     return `${API_BASE_URL}/api/user/file/${fileName}`;
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
//         <p className="text-gray-600 text-lg">Loading residents data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
//         <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
//           <div className="text-red-500 text-5xl mb-4">⚠️</div>
//           <h3 className="text-2xl font-bold text-gray-800 mb-2">
//             Error Loading Data
//           </h3>
//           <p className="text-gray-600 mb-6">{error}</p>
//           <button
//             onClick={fetchResidents}
//             className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 pb-6 border-b border-gray-200">
//           <div>
//             <h1 className="text-3xl font-bold text-gray-900">
//               Residents Information
//             </h1>
//             <p className="text-gray-600 mt-2">
//               View all registered residents and their details
//             </p>
//           </div>
//           <button
//             onClick={fetchResidents}
//             className="mt-4 md:mt-0 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-6 rounded-lg transition duration-300 shadow-md hover:shadow-lg"
//           >
//             <svg
//               className="w-5 h-5"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//               ></path>
//             </svg>
//             Refresh Data
//           </button>
//         </div>

//         {/* Residents Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {Array.isArray(residents) && residents.length > 0 ? (
//             residents.map((item, index) => (
//               <div
//                 key={item.resident?.id || index}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100"
//               >
//                 {/* Resident Header */}
//                 <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 border-b border-gray-100">
//                   <div className="flex items-center justify-between">
//                     <div>
//                       <h2 className="text-2xl font-bold text-gray-900">
//                         {item.resident?.residentName || "N/A"}
//                       </h2>
//                       <p className="text-gray-600 mt-1">
//                         Flat #{item.resident?.flatNumber || "N/A"}
//                       </p>
//                     </div>
//                     <div className="bg-blue-100 text-blue-800 font-semibold py-1 px-3 rounded-full text-sm">
//                       {item.resident?.totalMembers || "0"} Members
//                     </div>
//                   </div>
//                 </div>

//                 {/* Resident Details */}
//                 <div className="p-6">
//                   <div className="space-y-4">
//                     {/* Contact Info */}
//                     <div className="flex items-center gap-3 text-gray-700">
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                         />
//                       </svg>
//                       <span className="font-medium">
//                         {item.resident?.contactNumber || "N/A"}
//                       </span>
//                     </div>

//                     {/* Family Composition */}
//                     <div className="grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded-lg">
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-blue-600">
//                           {item.resident?.numberOfAdults || "0"}
//                         </div>
//                         <div className="text-sm text-gray-600">Adults</div>
//                       </div>
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-green-600">
//                           {item.resident?.numberOfChildren || "0"}
//                         </div>
//                         <div className="text-sm text-gray-600">Children</div>
//                       </div>
//                     </div>

//                     {/* Amount and UTR */}
//                     <div className="space-y-3">
//                       <div className="flex justify-between items-center bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-lg">
//                         <span className="font-medium text-gray-700">
//                           Total Amount:
//                         </span>
//                         <span className="text-2xl font-bold text-green-700">
//                           ₹{item.resident?.totalAmount?.toFixed(2) || "0.00"}
//                         </span>
//                       </div>

//                       <div className="bg-gray-50 p-4 rounded-lg">
//                         <div className="text-sm text-gray-500 mb-1">
//                           UTR Number
//                         </div>
//                         <div className="font-mono text-gray-800 bg-white p-2 rounded border border-gray-200 break-all">
//                           {item.resident?.utrNumber || "N/A"}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Payment Screenshot */}
//                     {item.resident?.paymentScreenshot && (
//                       <div className="mt-6 pt-6 border-t border-gray-100">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
//                           <svg
//                             className="w-5 h-5 text-gray-500"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
//                             />
//                           </svg>
//                           Payment Screenshot
//                         </h3>
//                         <div className="relative group">
//                           <div className="overflow-hidden rounded-lg border border-gray-200">
//                             <img
//                               src={getImageUrl(item.resident.paymentScreenshot)}
//                               alt={`Payment screenshot for ${item.resident.residentName}`}
//                               className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
//                               onError={(e) => {
//                                 e.target.src =
//                                   "https://via.placeholder.com/400x200?text=Image+Not+Available";
//                               }}
//                             />
//                             <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
//                           </div>
//                           <a
//                             href={getImageUrl(item.resident.paymentScreenshot)}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="mt-3 inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium text-sm"
//                           >
//                             <svg
//                               className="w-4 h-4"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                               />
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                               />
//                             </svg>
//                             View Full Image
//                           </a>
//                         </div>
//                       </div>
//                     )}

//                     {/* Success Message */}
//                     <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
//                       <div className="flex items-center gap-2 text-green-800">
//                         <svg
//                           className="w-5 h-5"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M5 13l4 4L19 7"
//                           ></path>
//                         </svg>
//                         <span className="font-medium">
//                           {item.message || "Resident registered successfully"}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-full flex flex-col items-center justify-center py-16">
//               <div className="text-gray-400 mb-4">
//                 <svg
//                   className="w-16 h-16 mx-auto"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="1"
//                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-gray-700 mb-2">
//                 No Residents Found
//               </h3>
//               <p className="text-gray-500 mb-6">
//                 There are no residents registered yet.
//               </p>
//               <button
//                 onClick={fetchResidents}
//                 className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
//               >
//                 Try Again
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Stats Footer */}
//         {Array.isArray(residents) && residents.length > 0 && (
//           <div className="mt-10 pt-6 border-t border-gray-200">
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-blue-600">
//                   {residents.length}
//                 </div>
//                 <div className="text-gray-600">Total Residents</div>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-green-600">
//                   {residents.reduce(
//                     (sum, item) => sum + (item.resident?.totalMembers || 0),
//                     0
//                   )}
//                 </div>
//                 <div className="text-gray-600">Total Members</div>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-purple-600">
//                   ₹
//                   {residents
//                     .reduce(
//                       (sum, item) => sum + (item.resident?.totalAmount || 0),
//                       0
//                     )
//                     .toFixed(2)}
//                 </div>
//                 <div className="text-gray-600">Total Amount</div>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-orange-600">
//                   {
//                     residents.filter((item) => item.resident?.paymentScreenshot)
//                       .length
//                   }
//                 </div>
//                 <div className="text-gray-600">With Screenshots</div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GetData;

// import React, { useState, useEffect } from "react";

// const GetData = () => {
//   const [residents, setResidents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const API_BASE_URL = "https://waapi.deetyasoft.com";

//   useEffect(() => {
//     fetchResidents();
//   }, []);

//   const fetchResidents = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/api/user/getAllResidents`);

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("API Response:", data); // Log to see the full response

//       // Check if data.residents exists, otherwise use data directly
//       if (data.residents && Array.isArray(data.residents)) {
//         setResidents(data.residents); // Use the residents array from the response
//       } else if (Array.isArray(data)) {
//         setResidents(data); // Fallback if response is directly an array
//       } else {
//         setResidents([]);
//         console.error("Unexpected API response format:", data);
//       }

//       setError(null);
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching residents:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Function to get image URL
//   const getImageUrl = (fileName) => {
//     if (!fileName) return null;
//     return `${API_BASE_URL}/api/user/file/${fileName}`;
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
//         <p className="text-gray-600 text-lg">Loading residents data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
//         <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
//           <div className="text-red-500 text-5xl mb-4">⚠️</div>
//           <h3 className="text-2xl font-bold text-gray-800 mb-2">
//             Error Loading Data
//           </h3>
//           <p className="text-gray-600 mb-6">{error}</p>
//           <button
//             onClick={fetchResidents}
//             className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-6">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 pb-6 border-b border-gray-200">
//           <div>
//             <h1 className="text-3xl font-bold text-gray-900">
//               Residents Information
//             </h1>
//             <p className="text-gray-600 mt-2">
//               View all registered residents and their details
//             </p>
//           </div>
//           <button
//             onClick={fetchResidents}
//             className="mt-4 md:mt-0 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-6 rounded-lg transition duration-300 shadow-md hover:shadow-lg"
//           >
//             <svg
//               className="w-5 h-5"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//               ></path>
//             </svg>
//             Refresh Data
//           </button>
//         </div>

//         {/* Residents Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {Array.isArray(residents) && residents.length > 0 ? (
//             residents.map((item, index) => (
//               <div
//                 key={item.id || index}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100"
//               >
//                 {/* Resident Header */}
//                 <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 border-b border-gray-100">
//                   <div className="flex items-center justify-between">
//                     <div>
//                       <h2 className="text-2xl font-bold text-gray-900">
//                         {item.residentName || "N/A"}
//                       </h2>
//                       <p className="text-gray-600 mt-1">
//                         Flat #{item.flatNumber || "N/A"}
//                       </p>
//                     </div>
//                     <div className="bg-blue-100 text-blue-800 font-semibold py-1 px-3 rounded-full text-sm">
//                       {item.totalMembers || "0"} Members
//                     </div>
//                   </div>
//                 </div>

//                 {/* Resident Details */}
//                 <div className="p-6">
//                   <div className="space-y-4">
//                     {/* Contact Info */}
//                     <div className="flex items-center gap-3 text-gray-700">
//                       <svg
//                         className="w-5 h-5 text-gray-400"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                         />
//                       </svg>
//                       <span className="font-medium">
//                         {item.contactNumber || "N/A"}
//                       </span>
//                     </div>

//                     {/* Family Composition */}
//                     <div className="grid grid-cols-2 gap-4 bg-gray-50 p-4 rounded-lg">
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-blue-600">
//                           {item.numberOfAdults || "0"}
//                         </div>
//                         <div className="text-sm text-gray-600">Adults</div>
//                       </div>
//                       <div className="text-center">
//                         <div className="text-lg font-bold text-green-600">
//                           {item.numberOfChildren || "0"}
//                         </div>
//                         <div className="text-sm text-gray-600">Children</div>
//                       </div>
//                     </div>

//                     {/* Amount and UTR */}
//                     <div className="space-y-3">
//                       <div className="flex justify-between items-center bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-lg">
//                         <span className="font-medium text-gray-700">
//                           Total Amount:
//                         </span>
//                         <span className="text-2xl font-bold text-green-700">
//                           ₹{item.totalAmount?.toFixed(2) || "0.00"}
//                         </span>
//                       </div>

//                       <div className="bg-gray-50 p-4 rounded-lg">
//                         <div className="text-sm text-gray-500 mb-1">
//                           UTR Number
//                         </div>
//                         <div className="font-mono text-gray-800 bg-white p-2 rounded border border-gray-200 break-all">
//                           {item.utrNumber || "N/A"}
//                         </div>
//                       </div>
//                     </div>

//                     {/* Payment Screenshot */}
//                     {item.paymentScreenshot && (
//                       <div className="mt-6 pt-6 border-t border-gray-100">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
//                           <svg
//                             className="w-5 h-5 text-gray-500"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth="2"
//                               d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
//                             />
//                           </svg>
//                           Payment Screenshot
//                         </h3>
//                         <div className="relative group">
//                           <div className="overflow-hidden rounded-lg border border-gray-200">
//                             <img
//                               src={getImageUrl(item.paymentScreenshot)}
//                               alt={`Payment screenshot for ${item.residentName}`}
//                               className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
//                               onError={(e) => {
//                                 e.target.src =
//                                   "https://via.placeholder.com/400x200?text=Image+Not+Available";
//                               }}
//                             />
//                             <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300"></div>
//                           </div>
//                           <a
//                             href={getImageUrl(item.paymentScreenshot)}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="mt-3 inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium text-sm"
//                           >
//                             <svg
//                               className="w-4 h-4"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
//                               />
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth="2"
//                                 d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                               />
//                             </svg>
//                             View Full Image
//                           </a>
//                         </div>
//                       </div>
//                     )}

//                     {/* Success Message - You might not have this in your current response */}
//                     <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
//                       <div className="flex items-center gap-2 text-green-800">
//                         <svg
//                           className="w-5 h-5"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M5 13l4 4L19 7"
//                           ></path>
//                         </svg>
//                         <span className="font-medium">
//                           Resident registered successfully
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="col-span-full flex flex-col items-center justify-center py-16">
//               <div className="text-gray-400 mb-4">
//                 <svg
//                   className="w-16 h-16 mx-auto"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="1"
//                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-gray-700 mb-2">
//                 No Residents Found
//               </h3>
//               <p className="text-gray-500 mb-6">
//                 There are no residents registered yet.
//               </p>
//               <button
//                 onClick={fetchResidents}
//                 className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
//               >
//                 Try Again
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Stats Footer */}
//         {Array.isArray(residents) && residents.length > 0 && (
//           <div className="mt-10 pt-6 border-t border-gray-200">
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-blue-600">
//                   {residents.length}
//                 </div>
//                 <div className="text-gray-600">Total Residents</div>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-green-600">
//                   {residents.reduce(
//                     (sum, item) => sum + (item.totalMembers || 0),
//                     0
//                   )}
//                 </div>
//                 <div className="text-gray-600">Total Members</div>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-purple-600">
//                   ₹
//                   {residents
//                     .reduce((sum, item) => sum + (item.totalAmount || 0), 0)
//                     .toFixed(2)}
//                 </div>
//                 <div className="text-gray-600">Total Amount</div>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow border border-gray-100 text-center">
//                 <div className="text-3xl font-bold text-orange-600">
//                   {residents.filter((item) => item.paymentScreenshot).length}
//                 </div>
//                 <div className="text-gray-600">With Screenshots</div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GetData;

import React, { useState, useEffect } from "react";

const GetData = () => {
  const [residents, setResidents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const API_BASE_URL = "https://waapi.deetyasoft.com";

  useEffect(() => {
    fetchResidents();
  }, []);

  const fetchResidents = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/user/getAllResidents`);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.residents && Array.isArray(data.residents)) {
        setResidents(data.residents);
      } else if (Array.isArray(data)) {
        setResidents(data);
      } else {
        setResidents([]);
        console.error("Unexpected API response format:", data);
      }

      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching residents:", err);
    } finally {
      setLoading(false);
    }
  };

  const getImageUrl = (fileName) => {
    if (!fileName) return null;
    return `${API_BASE_URL}/api/user/file/${fileName}`;
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedResidents = React.useMemo(() => {
    if (!sortConfig.key) return residents;

    return [...residents].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  }, [residents, sortConfig]);

  const filteredResidents = sortedResidents.filter((resident) => {
    return (
      resident.residentName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      resident.flatNumber?.toString().includes(searchTerm) ||
      resident.contactNumber?.includes(searchTerm) ||
      resident.utrNumber?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <span className="ml-1 opacity-30">↕️</span>;
    }
    return sortConfig.direction === "ascending" ? (
      <span className="ml-1">⬆️</span>
    ) : (
      <span className="ml-1">⬇️</span>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
        <p className="text-gray-600 text-lg">Loading residents data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-4">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
          <div className="text-red-500 text-5xl mb-4">⚠️</div>
          <h3 className="text-2xl font-bold text-gray-800 mb-2">
            Error Loading Data
          </h3>
          <p className="text-gray-600 mb-6">{error}</p>
          <button
            onClick={fetchResidents}
            className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-6 rounded-lg transition duration-300"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 pb-6 border-b border-gray-200">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Residents Information
            </h1>
            <p className="text-gray-600 mt-2">
              View all registered residents and their details
            </p>
          </div>
          <div className="flex items-center gap-4 mt-4 md:mt-0">
            <button
              onClick={fetchResidents}
              className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-6 rounded-lg transition duration-300 shadow-md hover:shadow-lg"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              Refresh
            </button>
          </div>
        </div>

        {/* Search and Stats */}
        <div className="mb-6">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
            <div className="relative flex-1 max-w-md">
              <input
                type="text"
                placeholder="Search by name, flat, contact, or UTR..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-3 pl-10 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <svg
                className="absolute left-3 top-3.5 w-5 h-5 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <div className="text-gray-600">
              Showing{" "}
              <span className="font-bold">{filteredResidents.length}</span> of{" "}
              <span className="font-bold">{residents.length}</span> residents
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-white p-4 rounded-lg shadow border border-gray-100">
              <div className="text-2xl font-bold text-blue-600">
                {residents.length}
              </div>
              <div className="text-gray-600 text-sm">Total Residents</div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow border border-gray-100">
              <div className="text-2xl font-bold text-green-600">
                {residents.reduce(
                  (sum, item) => sum + (item.totalMembers || 0),
                  0
                )}
              </div>
              <div className="text-gray-600 text-sm">Total Members</div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow border border-gray-100">
              <div className="text-2xl font-bold text-purple-600">
                ₹
                {residents
                  .reduce((sum, item) => sum + (item.totalAmount || 0), 0)
                  .toFixed(2)}
              </div>
              <div className="text-gray-600 text-sm">Total Amount</div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow border border-gray-100">
              <div className="text-2xl font-bold text-orange-600">
                {residents.filter((item) => item.paymentScreenshot).length}
              </div>
              <div className="text-gray-600 text-sm">With Screenshots</div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort("residentName")}
                  >
                    <div className="flex items-center">
                      Resident Name
                      <SortIcon columnKey="residentName" />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort("flatNumber")}
                  >
                    <div className="flex items-center">
                      Flat Number
                      <SortIcon columnKey="flatNumber" />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Contact
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort("totalMembers")}
                  >
                    <div className="flex items-center">
                      Members
                      <SortIcon columnKey="totalMembers" />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                    onClick={() => handleSort("totalAmount")}
                  >
                    <div className="flex items-center">
                      Amount (₹)
                      <SortIcon columnKey="totalAmount" />
                    </div>
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    UTR Number
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Payment Screenshot
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Family Composition
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredResidents.length > 0 ? (
                  filteredResidents.map((item, index) => (
                    <tr
                      key={item.id || index}
                      className="hover:bg-gray-50 transition-colors duration-150"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">
                              {item.residentName || "N/A"}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">
                          {item.flatNumber || "N/A"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {item.contactNumber || "N/A"}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 font-semibold">
                          {item.totalMembers || "0"}
                        </div>
                        <div className="text-xs text-gray-500">
                          {item.numberOfAdults || "0"} Adults,{" "}
                          {item.numberOfChildren || "0"} Children
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-bold text-green-700">
                          ₹{item.totalAmount?.toFixed(2) || "0.00"}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-mono text-gray-900 bg-gray-50 p-2 rounded border border-gray-200 break-all max-w-xs">
                          {item.utrNumber || "N/A"}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.paymentScreenshot ? (
                          <div className="flex items-center space-x-2">
                            <div className="relative group">
                              <img
                                src={getImageUrl(item.paymentScreenshot)}
                                alt="Payment"
                                className="w-16 h-12 object-cover rounded border border-gray-300 cursor-pointer hover:opacity-90 transition-opacity"
                                onError={(e) => {
                                  e.target.src =
                                    "https://via.placeholder.com/64x48?text=Image+Error";
                                }}
                              />
                              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300 rounded"></div>
                            </div>
                            <a
                              href={getImageUrl(item.paymentScreenshot)}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                            >
                              View
                            </a>
                          </div>
                        ) : (
                          <span className="text-gray-400 text-sm">
                            No screenshot
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex space-x-2">
                          <div className="text-center">
                            <div className="text-lg font-bold text-blue-600">
                              {item.numberOfAdults || "0"}
                            </div>
                            <div className="text-xs text-gray-600">Adults</div>
                          </div>
                          <div className="text-center">
                            <div className="text-lg font-bold text-green-600">
                              {item.numberOfChildren || "0"}
                            </div>
                            <div className="text-xs text-gray-600">
                              Children
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="px-6 py-12 text-center">
                      <div className="flex flex-col items-center justify-center">
                        <svg
                          className="w-16 h-16 text-gray-400 mb-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="1"
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <h3 className="text-lg font-semibold text-gray-700 mb-2">
                          No Residents Found
                        </h3>
                        <p className="text-gray-500 mb-4">
                          {searchTerm
                            ? "Try a different search term"
                            : "There are no residents registered yet"}
                        </p>
                        {searchTerm && (
                          <button
                            onClick={() => setSearchTerm("")}
                            className="text-blue-600 hover:text-blue-800 font-medium"
                          >
                            Clear search
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Summary Footer */}
        {filteredResidents.length > 0 && (
          <div className="mt-6 pt-6 border-t border-gray-200 text-sm text-gray-600">
            <div className="flex justify-between items-center">
              <div>
                Showing {filteredResidents.length} residents
                {searchTerm && (
                  <span className="ml-2 text-blue-600">
                    (filtered from {residents.length} total)
                  </span>
                )}
              </div>
              <div className="text-right">
                <div className="text-gray-700">
                  Total Amount:{" "}
                  <span className="font-bold text-green-700">
                    ₹
                    {filteredResidents
                      .reduce((sum, item) => sum + (item.totalAmount || 0), 0)
                      .toFixed(2)}
                  </span>
                </div>
                <div className="text-xs text-gray-500 mt-1">
                  Click on column headers to sort
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GetData;
